import React from 'react'

import classNames from 'classnames'

type Props = React.AnchorHTMLAttributes<HTMLAnchorElement>

const ExternalLink: React.FC<Props> = ({ title, children, className, ...props }: Props) => (
  <a
    className={classNames('link', className)}
    title={title}
    target="_blank"
    rel="noopener noreferrer"
    {...props}>
    {children}
  </a>
)

export default ExternalLink
